import React, { useRef, useEffect, useState } from "react";

const InputRange = ({onSliderChange}) => {
    const rangeSliderRef = useRef(null);
    const rangeBulletRef = useRef(null);
    const [sliderValue, setSliderValue] = useState(20);

    const handleSliderChange = (event) => {
        const newValue = event.target.value;
        setSliderValue(newValue);
        onSliderChange(newValue);
    };

    useEffect(() => {
        const rangeSlider = rangeSliderRef.current;
        const rangeBullet = rangeBulletRef.current;
        rangeSlider.style.background = "#B9C0C2"

        const showSliderValue = () => {
            rangeBullet.innerHTML = rangeSlider.value;
            let bulletPosition = (rangeSlider.value - rangeSlider.min) / (rangeSlider.max - rangeSlider.min);
            rangeBullet.style.left = bulletPosition * (rangeSlider.clientWidth - 13) + "px";
            if (rangeSlider.value >= 31) {
                rangeSlider.style.background = `linear-gradient(to right, #000 ${bulletPosition * 100}%, #B9C0C2 ${bulletPosition * 100}%)`;
            }
        };

        rangeSlider.addEventListener("input", showSliderValue, false);

        return () => {
            rangeSlider.removeEventListener("input", showSliderValue);
        };
    }, []);

    return (
        <div className="input__range">
            <div className="range-slider">
                <span ref={rangeBulletRef} className="rs-label">31</span>
                <input
                    ref={rangeSliderRef}
                    className="rs-range"
                    type="range"
                    onChange={handleSliderChange}
                    defaultValue="31"
                    min="31"
                    max="40"
                />
            </div>
            <div className="box-minmax">
                <span>Mínimo 31%</span><span>Máximo 40%</span>
            </div>
        </div>
    );
};

export default InputRange;
